export default __webpack_public_path__ + "static/muhammad-b4c8f3f049181a4b5b1eec7c315dc0bd.png";